export default "__VITE_ASSET__BRxgKun3__"